import { defineStore } from 'pinia';

// Modal "Baixe o aplicativo" (ENG-495). Abre via store, sem navegar de rota —
// hoje só pelo deep-link `?open=modal-aplicativo`, mas qualquer botão pode
// chamar `open()`. Sem gate de login nem de flag: é um convite público.
export const useAppDownloadStore = defineStore('app-download', () => {
  const isOpen = ref(false);

  function open() {
    isOpen.value = true;
  }

  function close() {
    isOpen.value = false;
  }

  return { isOpen, open, close };
});
